import { memo } from "react";
import { MessageSquareQuote } from "lucide-react";
import { TestimonialSlider } from "../../../common/sections/Testimonial";
import Kaia from '@/assets/images/home/testimonial/kaia.png';
import SpsAutocare from '@/assets/images/home/testimonial/spsauto.png';
import Mannhomes from '@/assets/images/home/testimonial/mannhomes.png';
import Rightpath from '@/assets/images/home/testimonial/rightpath.png';
import XpertEngineers from '@/assets/images/home/testimonial/xpert-engineers.png';
import Nepalsaihatya from '@/assets/images/home/testimonial/nepalsaihatya.png';
import JavaEnergy from '@/assets/images/home/testimonial/javaenergy.png';
import EWNC from '@/assets/images/home/testimonial/EWNC.png';
import EightyGraphics from '@/assets/images/home/testimonial/80-graphics.png';
import ColorateSigns from '@/assets/images/home/testimonial/colorate-logo.png';
import NewConceptFinance from '@/assets/images/home/testimonial/new-concept-finance.png';
import ConnectingHand from '@/assets/images/home/testimonial/connecting-hands.png';
// Static data outside component — allocated once, never recreated
const testimonials = [
    {
        id: '1',
        name: 'Nepali Sahitya Samaj',
        position: 'CEO',
        company: 'Tech Innovators Pvt. Ltd.',
        description: 'SAN micron transformed our business technology landscape. Their IT consulting helped us streamline our operations and reduce downtime significantly. Exceptional service from start to finish!',
        logo: Nepalsaihatya,
    },
    {
        id: '2',
        name: 'Mannhomes',
        position: 'Operations Head',
        company: 'Global Retail Group',
        description: 'We partnered with SAN micron for cloud solutions and managed IT support. Their proactive approach keeps our infrastructure secure and running smoothly 24/7. Highly recommended!',
        logo: Mannhomes,
    },
    {
        id: '3',
        name: 'Xpertengineering',
        position: 'Product Manager',
        company: 'EduTech Solutions',
        description: 'The team at SAN micron built custom web and mobile applications that perfectly matched our vision. Their expertise in software development and UX design made the entire process seamless.',
        logo: XpertEngineers,
    },
    {
        id: '4',
        name: 'Right Path Realestate',
        position: 'CTO',
        company: 'Future Finance Ltd.',
        description: "SAN micron's IT consulting services helped us realign our digital strategy for better performance and scalability. Their insights and support have been invaluable.",
        logo: Rightpath,
    },
    {
        id: '7',
        name: 'Java Energy',
        position: 'Operations Director',
        company: 'Java Energy',
        description: "SAN micron rebuilt our web presence and backend systems from the ground up. Our site is faster, our team spends less time on manual reporting, and support has been fast whenever we've needed it.",
        logo: JavaEnergy,
    },
    {
        id: '8',
        name: 'SPS Autocare',
        position: 'General Manager',
        company: 'SPS Autocare',
        description: "SAN micron built us a booking and customer management system that actually fits how our workshop runs day to day. Fewer missed appointments, less admin, and it just works.",
        logo: SpsAutocare,
    },
    {
        id: '9',
        name: 'Kaia Lawyers',
        position: 'Managing Partner',
        company: 'Kaia Lawyers',
        description: "Our new site needed to feel professional and trustworthy from the first click. SAN micron delivered exactly that, and were easy to work with through every round of feedback.",
        logo: Kaia,
    },
    {
        id: '10',
        name: 'EWNC',
        position: 'Managing Director',
        company: 'EWNC',
        description: "SAN micron took the time to understand what we actually needed instead of pushing a template solution. The result was a platform that fit our business, delivered on time and within budget.",
        logo: EWNC,
    },
    {
        id: '11',
        name: '80graphics',
        position: 'Director',
        company: '80graphics',
        description: "SAN micron helped improve our website's SEO and online visibility with practical, ongoing optimisation. They made it easier for our business to reach the right audience through search.",
        logo: EightyGraphics,
    },

    {
        id: '12',
        name: 'Colorate Signs',
        position: 'Director',
        company: 'Colorate Signs',
        description: "SAN micron helped strengthen our SEO and improve our website's visibility in search results. Their ongoing optimisation and attention to detail have made a noticeable difference to our online presence.",
        logo: ColorateSigns,
    }, 
    {
        id: '13',
        name: 'Connecting Hands',
        position: 'Director',
        company: 'Connecting Hands',
        description: "SAN micron designed and developed a professional website that clearly represents our organisation and makes it easier for visitors to find the information they need. The team was responsive and easy to work with throughout the project.",
        logo: ConnectingHand,
    },
    {
        id: '14',
        name: 'New Concept Finance',
        position: 'Director',
        company: 'New Concept Finance',
        description: "SAN micron helped us build a professional website that clearly presents our financial services and makes it easier for clients to understand what we offer. The team was responsive, professional, and easy to work with throughout the project.",
        logo: NewConceptFinance,
    },
    // {
    //     id: '11',
    //     name: 'Neon Shop',
    //     position: 'Founder',
    //     company: 'Neon Shop',
    //     description: "SAN micron built us an online store that's fast, easy to update, and actually converts. From product pages to checkout, everything just feels smooth.",
    //     logo: TestimonialLogo,
    // }
];

// memo — this component has no props and no state, so it never needs to re-render
const DigitalOperating = memo(function DigitalOperating() {
    return (
        <div className="container py-6" style={{ scrollMarginTop: '100px' }} id="testimonials">
            <div className="text-center mb-8 md:mb-12 transform-gpu">
                <div className="inline-flex items-center gap-2.5 px-5 py-2.5 mb-8 bg-white/5 rounded-full border border-white/10">
                    <MessageSquareQuote className="w-4 h-4 text-cyan-400" />
                    <span className="text-xs md:text-sm font-semibold text-gray-300 tracking-widest uppercase">
                        Client Success Stories
                    </span>
                </div>

                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-7 leading-tight tracking-tight">
                    What Our
                    <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent pl-2">
                        Clients Say
                    </span>
                </h2>

                <p className="text-base md:text-lg text-gray-300 max-w-3xl mx-auto leading-relaxed">
                    Aligning Technology, Processes, and People for the Digital Era
                </p>
            </div>
            <TestimonialSlider testimonials={testimonials} />
        </div>
    );
});

export default DigitalOperating;